module.exports = __webpack_public_path__ + "img/project_image1.38267616.png";